import _ from 'lodash';
import { t } from '../../../../../../i18n';
import { withTZ, getFormattedDate } from '../../../../../../helpers/dateTime';

export const transformEventsObjects = events => {
  const arrayOfEvents = [];

  _.keys(events).forEach(date => {
    const event = events[date];
    const start = withTZ(date);
    const end = withTZ(date);

    // Orange indicator with number of job invites received for a shift that starts that day.
    if (event.invites && event.invites > 0) {
      arrayOfEvents.push({
        label: t('dash.talent.invites_title', { value: event.invites }),
        type: 'orange',
        start,
        end,
      });
    }

    // Green indicator with start time of a shift that was accepted and worked
    // Green indicator with start time of an accepted or confirmed shift in the future
    if (event.shifts_data && event.shifts_data.worked && event.shifts_data.worked.length > 0) {
      event.shifts_data.worked.forEach(shift => {
        arrayOfEvents.push({
          label: (shift.status && shift.status.name) || '',
          time: getFormattedDate({ date: shift.started_at, formatKey: 'time_hours_minutes_long' }),
          type: 'green',
          start,
          end,
          icon: shift.reported_by_client, // a warning icon if the shift was reported by the client
        });
      });
    }

    // Red indicator with "Canceled < 24 hours" for job invites in canceled status
    if (event.shifts_data && event.shifts_data.cancelled > 0) {
      arrayOfEvents.push({
        label: t('dash.talent.canceled_title', { value: event.shifts_data.cancelled }),
        type: 'red',
        start,
        end,
      });
    }

    // Red indicator with "Removed" for job invites in removed status
    if (event.shifts_data && event.shifts_data.removed > 0) {
      arrayOfEvents.push({
        label: t('dash.talent.removed_title', { value: event.shifts_data.removed }),
        type: 'red',
        start,
        end,
      });
    }

    // Red indicator with "Never" for shifts rated "Never" by the client
    if (event.shifts_data && event.shifts_data.rated_never > 0) {
      arrayOfEvents.push({
        label: t('dash.talent.never_title', { value: event.shifts_data.rated_never }),
        type: 'red',
        start,
        end,
      });
    }

    // Red indicator with "NCNS" for Business reported shifts (NCNS marked shifts)
    if (event.shifts_data && event.shifts_data.no_call_no_show > 0) {
      arrayOfEvents.push({
        label: t('dash.talent.ncns_title', { value: event.shifts_data.no_call_no_show }),
        type: 'red',
        start,
        end,
      });
    }
  });

  return arrayOfEvents;
};
